import { React, useState, Fragment, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import apiService from '../../services/apiServices';
import validationSchema from '../../services/validationSchema';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { yupResolver } from '@hookform/resolvers/yup';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Moment from 'react-moment';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import ExtraHours from './ExtraHours';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
} from 'react-router-dom';
import { Bars } from 'react-loader-spinner';
import ExportData from './ExportData';


export default function AddList() {
  //const classes = useStyles();
  const status = { added: 1, deleted: -1, changed: 2, unchanged: 0 };
  const obj = { WorkerId: 0, Advances: 0, id: 0, Salary: 0.0, Advances: 0.0, ExtraHours: 0, ExtraHoursWeekend: 0, ExtraHoursHoliday: 0, HourSalary: 0.0, Bonus: 0.0, Penalties: 0.0, editMode: false, no: 1, SalaryDate: "", status: 0 }
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [salaries, setSalaries] = useState([obj]);
  const [workers, setWorkers] = useState([]);
  const [months, setMonths] = useState([]);
  const [worker, setWorker] = useState([]);
  const [modal, setModal] = useState([]);
  const [loader, setLoader] = useState(true);
  const [fiscalPolitics, setFiscalPolitics] = useState();
  const [fiscalPoliticDetails, setFiscalPoliticDetails] = useState()

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm();
  let { id } = useParams();

  const onRowClick = (no) => {
    let rowItem = [...salaries]
    rowItem.forEach(i => i.editMode = false);
    rowItem[no - 1].editMode = !rowItem[no - 1].editMode;
    setSalaries(rowItem);
  }

  const addRow = () => {
    let newItem = obj
    newItem.no = Math.max(...salaries.map(o => o.no), 0) + 1
    const newState = [...salaries, newItem];
    setSalaries(countItems(newState))
  }

  const getContracts = (arr) => {
    arr.map(a => {
      apiService()
        .query('getWorkerContracts', 'id=' + a.WorkerId)
        .then((wc) => {
          if (wc.success && wc.data.length > 0) {
            let d = wc.data
            //return d[d.length - 1]
            let newArr = [...arr];
            newArr[a.no - 1].Salary = parseFloat(d[d.length - 1]['BaseSalary'])
            newArr[a.no - 1].EmployeeTax = parseFloat(d[d.length - 1]['EmployeeTax'])
            newArr[a.no - 1].EmployerTax = parseFloat(d[d.length - 1]['EmployerTax'])
            setSalaries(newArr);
            getFiscalPolitics(newArr)
            setValues(newArr)
          } else {
            console.log('Error1:' + wc.errorMessage);
          }
        });
    })
    //setSalaries(arr)
  }

  const addAllWorkers = () => {
    let arr = []
    let newItem = { ...obj };
    workers.map(w => {
      newItem = { ...obj }
      newItem.WorkerId = w.id
      arr.push(newItem)
      newItem = {}
    })
    getContracts(reOrderItems(arr))
  }

  const set_State = () => {
    let st = [...salaries];
    setSalaries(st)
  }

  const deleteRow = (rowId) => {
    let arrayCopy = [...salaries]
    let item = arrayCopy.find(i => i.no === rowId);
    item.status = -1; //status.deleted;
    //arrayCopy = arrayCopy.filter((row) => row.status !== -1);
    const newArr = [countItems(arrayCopy)]
    setSalaries(countItems(arrayCopy))
  }

  const countItems = (arr) => {
    let count = 1;
    arr.forEach(i => { i.no = count; count++ });
    return arr;
  }

  const onValueChange = (no) => {
    let newArr = [...salaries];
    newArr[no - 1]['status'] = status.changed;
    newArr[no - 1]['WorkerId'] = watch('WorkerId_' + no).id
    newArr[no - 1]['Salary'] = parseFloat(watch('Salary_' + no))
    newArr[no - 1]['Advances'] = parseFloat(watch('Advances_' + no))
    newArr[no - 1]['ExtraHours'] = parseFloat(watch('ExtraHours_' + no))
    newArr[no - 1]['HourSalary'] = parseFloat(watch('HourSalary_' + no))
    newArr[no - 1]['Bonus'] = parseFloat(watch('Bonus_' + no))
    newArr[no - 1]['Penalties'] = parseFloat(watch('Penalties_' + no))
    setSalaries(newArr);
    prepareEmployeeCard(fiscalPoliticDetails, newArr)
  }

  const total = (no) => {
    let s = watch("Salary_" + no) ? parseFloat(watch("Salary_" + no)) : 0
    let a = watch("Advances_" + no) ? parseFloat(watch("Advances_" + no)) : 0
    let hs = watch("HourSalary_" + no) ? parseFloat(watch("HourSalary_" + no)) : 0
    let b = watch("Bonus_" + no) ? parseFloat(watch("Bonus_" + no)) : 0
    let p = watch("Penalties_" + no) ? parseFloat(watch("Penalties_" + no)) : 0
    return s + hs + b - a - p
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const getWorkers = () => {
    apiService().get('selectworker')
      .then((response) => {
        if (response.success) {
          setWorkers(response.data);
        } else {
          alert('Error:' + response.errorMessage);
        }
      });
  }

  const getSalariesMonthlyList = (id) => {
    apiService().query('getSalariesMonthlyList', `id=${id}`)
      .then((response) => {
        if (response.success) {
          let rsp = response.data[0]
          getSalariesByListId(response.data[0])
          setValue('year', rsp.year)
          setValue('month', months.find(m => m.id === rsp.month))
        }
      })
  }

  const getSalariesByListId = (list) => {
    apiService().query('getSalariesByListId', `id=${list.id}`)
      .then((response) => {
        if (response.success) {
          let results = response.data
          results = setEditModeFalse(results)
          setSalaries(reOrderItems(results))
          getContracts(reOrderItems(results))
          setValues(reOrderItems(results))
          setLoader(false)
        }
      })
  }

  const setEditModeFalse = (items) => {
    return items.map(obj => ({ ...obj, editMode: false }))
  }

  const setValues = (items) => {
    items.forEach(i => {
      setValue('WorkerId_' + i.no, workers?.find(w => w.id === i.WorkerId))
      setValue('Salary_' + i.no, i.Salary)
      setValue('Advances_' + i.no, i.Advances)
      setValue('ExtraHours_' + i.no, i.ExtraHours)
      setValue('HourSalary_' + i.no, i.HourSalary)
      setValue('Bonus_' + i.no, i.Bonus)
      setValue('Penalties_' + i.no, i.Penalties)
      i.status = status.unchanged
    });
  }

  function salary(user, no) {
    apiService()
      .query('getWorker', 'id=' + user.id)
      .then((response) => {
        if (response.success && response.data.length > 0) {
          let w = response.data[0]
          setWorker(w)
          setValue('Salary_' + no, w.BaseSalary ? w.BaseSalary : 0)
          //setValue('HourSalary_'+no, w.HourSalary ? w.HourSalary : 0)
        }
        else {
          setValue('Salary_' + no, 0)
          setValue('HourSalary_' + no, 0)
        }
      });
  }

  const handleClose = (value) => {
    setModal({ open: value })
  };

  const openModal = (id, no, item, open) => {
    setModal({
      open: open ? open : false,
      tittle: 'Orët shtesë',
      // message: 'Do you want to delete this row?',
      id: id,
      no: no,
      item: item
    });
    //setToast({ open: false });
    //setRowId(id);
  };

  const showAddAllWorkers = () => {
    if (salaries?.length < 2 && salaries[0]?.WorkerId === 0 || salaries?.every(isDeleted)) {
      return true
    }
    else {
      return false
    }
  }

  const isDeleted = (currentValue) => currentValue.status === -1;

  const getFiscalPolitics = (obj) => {
    apiService().get('fiscalPolitics')
      .then(response => {
        if (response.success) {
          getFiscalpoliticsDetails(response?.data[0]?.Id, obj)
          setFiscalPolitics(response?.data[0])
        }
      })
  }

  const getFiscalpoliticsDetails = (id, obj) => {
    apiService().query('getFiscalpoliticsDetails', `FiscalPoliticsId=${id}`)
      .then(response => {
        if (response.success) {
          prepareEmployeeCard(response.data, obj)
          setFiscalPoliticDetails(response?.data)
        }
      })
  }

  const prepareEmployeeCard = (fiscalRanges, obj) => {
    let employees = obj;

    employees?.forEach(emp => {
      emp["employeeTaxFee"] = (emp?.EmployeeTax / 100) * emp?.Salary
      emp["employerTaxFee"] = (emp?.EmployerTax / 100) * emp?.Salary
      emp["contributions"] = (emp?.EmployerTax / 100) * emp?.Salary + (emp?.EmployeeTax / 100) * emp?.Salary

      emp["taxes"] = calcualateTaxes(emp?.Salary - ((emp?.EmployeeTax / 100) * emp?.Salary), fiscalRanges)
      emp["neto"] = (emp?.Salary - ((emp?.EmployeeTax / 100) * emp?.Salary)) - calcualateTaxes(emp?.Salary - ((emp?.EmployeeTax / 100) * emp?.Salary), fiscalRanges)
      emp["total"] = (emp?.Salary - ((emp?.EmployeeTax / 100) * emp?.Salary)) - calcualateTaxes(emp?.Salary - ((emp?.EmployeeTax / 100) * emp?.Salary), fiscalRanges) + emp?.Bonus - emp?.Penalties

    });
    //setEmployeeCard(employees)
    setSalaries(employees)
    setLoader(false)
  }

  const calcualateTaxes = (salary, fiscalRanges) => {
    let total = 0;
    for (let i = 0; i < fiscalRanges?.length; i++) {
      if (salary > fiscalRanges[i].To) {
        if (fiscalRanges[i].To !== null) {
          total += (fiscalRanges[i].To - fiscalRanges[i].From) * fiscalRanges[i].Tax / 100;
        }
        else {
          if (salary > fiscalRanges[i].From) {
            total += (salary - fiscalRanges[i].From) * fiscalRanges[i].Tax / 100;
          }
        }
      }
      else {
        if (salary > fiscalRanges[i].From && salary < fiscalRanges[i].To) {
          total += (salary - fiscalRanges[i].From) * fiscalRanges[i].Tax / 100
        }
      }
    }
    return total
  }

  useEffect(() => {
    apiService()
      .get('months')
      .then((response) => {
        if (response.success) {
          setMonths(response.data);
        } else {
          alert('Error:' + response.errorMessage);
        }
      });

    let date = new Date();
    setValue('year', date.getFullYear())
    getWorkers()
  }, []);

  useEffect(() => {
    if (id) {
      getSalariesMonthlyList(id);
    }
  }, [workers]);

  const onSubmit = (data) => {
    data.month = data.month.id;
    data.createdBy = "Admin"
    if (id) {
      saveSalariesMonthlyList(data)
    }
    else {
      checkList(data)
    }

  };

  const checkList = (data) => {
    apiService().query('checkList', `month=${data.month}&year=${data.year}`)
      .then((response) => {
        if (response.success && response.data.length > 0) {
          setToast({
            open: true,
            message: 'Kjo liste ekziston!',
            variant: 'warning',
          });
        }
        else {
          saveSalariesMonthlyList(data)
        }
      })
  }

  const saveSalariesMonthlyList = (data) => {
    if (id) {
      data.id = id;
      apiService()
        .put('salariesmonthlylists', data)
        .then((response) => {
          if (response.success) {
            saveSalaries({ id: id, month: watch('month').id })
          } else {
            setToast({
              open: true,
              message: 'Ka ndodhur nje gabim!',
              variant: 'error',
            });
          }
        });
    }
    else {
      apiService()
        .post('salariesmonthlylists', data)
        .then((response) => {
          if (response.success) {
            saveSalaries(response.data)
          } else {
            setToast({
              open: true,
              message: 'Ka ndodhur nje gabim!',
              variant: 'error',
            });
          }
        });
    }
  }

  const reOrderItems = (items) => {
    let count = 1;
    items.forEach(i => {
      if (i.status !== -1) {
        i.no = count;
        count++
      }
      else {
        i.no = 0;
      }
    });

    return items;
  }

  const saveSalaries = (list) => {
    let objs = [], items = reOrderItems([...salaries]), objE = {};

    items?.forEach(item => {
      item.listId = list.id;
      item.month = list.month;
      if (item.id === 0) {
        objE = {};
        objE.id = 0;
        objE.entity = item;
        objE.status = status.added;
        objE.type = "salaries";

        if (item.WorkerId !== 0 && item.no !== 0 && item.status !== -1) {
          objs.push(objE);
        }
      }
      else {
        objE = {};
        objE.entity = item;
        objE.status = item.status ? item.status : status.unchanged;
        objE.type = "salaries";
        if (objE.status !== status.unchanged) {
          objs.push(objE)
        }
      }
    });

    if (objs.length > 0) {
      apiService().saveChanges(objs)
        .then((response) => {
          if (response.success) {
            setToast({
              open: true,
              message: 'U ruajten me sukses!',
              variant: 'success',
            });
            setSalaries(setEditModeFalse(salaries))
            if (!id) {
              window.location.href = '#/salarieslist/editlist/' + list.id
            }
          }
          else {
            setToast({
              open: true,
              message: 'Ka ndodhur nje gabim!',
              variant: 'error',
            });
          }
        })
    }
    else {
      if (id) {
        setToast({
          open: true,
          message: 'Nuk ka ndryshime!',
          variant: 'info',
        });
      }
      else {
        setToast({
          open: true,
          message: 'U ruajten me sukses!',
          variant: 'success',
        });
      }

    }
  }

  const setExtraHours = (eh, ehw, ehh, no, hs) => {
    //setValue(salaries[0]['ExtraHours'], c)
    let newArr = [...salaries];
    newArr[no - 1]['status'] = status.changed;
    newArr[no - 1]['ExtraHours'] = parseFloat(eh)
    newArr[no - 1]['ExtraHoursWeekend'] = parseFloat(ehw)
    newArr[no - 1]['ExtraHoursHoliday'] = parseFloat(ehh)
    newArr[no - 1]['HourSalary'] = parseFloat(hs)
    setSalaries(newArr);
    setValues(newArr)
  }

  const exportCsv = (fileName = 'test') => {
    var htmls = "";
    var table = document.getElementById('content_table') ? document.getElementById('content_table') : document.getElementById('table-to-xls-1');
    htmls = table?.outerHTML;
    console.log(salaries)

    var link = document.createElement("a");
    link.download = fileName + ".xls";
    link.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(htmls);
    link.click();
  }

  const calculateColumnTotal = (data, property) => {
    return parseFloat(data?.reduce((accumulator, current) => parseFloat(accumulator) + parseFloat(current[property] ? current[property] : 0), 0)).toFixed(2)
  }

  return (
    <div className="">
      <ExportData salaries={salaries} workers={workers} />
      <ExtraHours {...modal} handleClose={(id) => handleClose(id)} setHours={setExtraHours} />
      <Fragment>
        <Toast {...toast} />
        <TopActions
          //newHref={addRow()}
          addNew={() => addRow()}
          save={handleSubmit(onSubmit)}
          addAllWorkers={showAddAllWorkers() ? () => addAllWorkers() : 0}
          exportToCsv={() => exportCsv()}
        />
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Lista e pagave
            </Typography>
            <form>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Muaji"
                    error={errors.month}
                    control={control}
                    options={months}
                    name="month"
                    register={{ ...register('month') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Viti"
                    error={errors.year}
                    control={control}
                    type="number"
                    register={{ ...register('year') }}
                  />
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
        <Card style={{ marginTop: '16px' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Lista e punetoreve
            </Typography>
            {/* {loader && <Bars
              height="100"
              width="80%"
              color="#1976d2"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />} */}
            {/* {!loader && <> */}
            <TableContainer component={Paper}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {/* <TableCell style={{width: '20px'}}>Edit</TableCell> */}
                    <TableCell>Nr</TableCell>
                    <TableCell style={{ width: '300px' }}>Punëtori</TableCell>
                    {/* <TableCell>Muaji</TableCell> */}
                    {/* <TableCell style={{width: '80px'}}>Data</TableCell> */}
                    <TableCell>Paga</TableCell>
                    <TableCell>Avanci</TableCell>
                    <TableCell>Orët shtesë</TableCell>
                    <TableCell>Pagesa për Orë shtesë</TableCell>
                    <TableCell>Kontributet</TableCell>
                    <TableCell>Taksat</TableCell>
                    <TableCell>Paga neto</TableCell>
                    <TableCell>Bonuset</TableCell>
                    <TableCell>Ndeshkimet</TableCell>
                    <TableCell>Totali</TableCell>
                    <TableCell>Add/Remove</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {salaries
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((w, index) => (w.status !== -1 &&
                      <TableRow key={w.id + index}>
                        {/* <TableCell>
                    <ButtonGroup size="small">
                      <Link to={`/salarieslist/editsalary/${w.Id}`}>
                        <Button>
                          <EditIcon />
                        </Button>
                      </Link>
                    </ButtonGroup>
                  </TableCell> */}
                        <TableCell>{index + 1}</TableCell>
                        {w.editMode ?
                          <TableCell>
                            <SelectController onChangeProp={() => onValueChange(w.no)} salary={(e) => salary(e, w.no)} error={errors.WorkerId} control={control} options={workers} name={`WorkerId_${w.no}`} value={workers.find(i => i.id === w.WorkerId)} register={{ ...register('WorkerId_' + w.no) }} />
                          </TableCell>
                          :
                          <TableCell onClick={function () { onRowClick(w.no) }}>{workers.find(i => i.id === w.WorkerId)?.name}</TableCell>
                        }
                        {/* {w.editMode ?
                    <TableCell><SelectController error={errors.Month} control={control} options={months} name="Month" register={{ ...register('Month') }} /></TableCell>
                    :
                  <TableCell onClick={function () { onRowClick(w.no) }}>{months.find(m => m.id == w.Month)?.name}</TableCell>
                  }      */}
                        {/* {
                    w.editMode ? 
                    <TableCell>
                      <InputController error={errors.SalaryDate} control={control} type="date" register={{ ...register('SalaryDate') }} />
                    </TableCell>
                    :
                    <TableCell onClick={function () { onRowClick(w.no) }}>
                      <Moment format="DD/MM/YYYY">{w.SalaryDate}</Moment>
                    </TableCell>
                  } */}
                        {
                          w.editMode ?
                            <TableCell>
                              <InputController onFieldChange={() => onValueChange(w.no)} error={errors['Salary_' + w.no]} control={control} symbol="€" register={{ ...register('Salary_' + w.no) }} />
                            </TableCell>
                            :
                            <TableCell onClick={function () { onRowClick(w.no) }}>
                              {new Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(w.Salary)}
                            </TableCell>
                        }
                        {
                          w.editMode ?
                            <TableCell><InputController onFieldChange={() => onValueChange(w.no)} error={errors['Advances_' + w.no]} control={control} symbol="€" register={{ ...register('Advances_' + w.no) }} /></TableCell>
                            :
                            <TableCell onClick={function () { onRowClick(w.no) }}>
                              {new Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(w.Advances)}
                            </TableCell>
                        }
                        {
                          <TableCell>
                            <Button onClick={() => openModal(w.WorkerId, w.no, w, true)}>
                              <AddIcon />
                              {w.ExtraHours + w.ExtraHoursWeekend + w.ExtraHoursHoliday}
                            </Button>
                          </TableCell>
                          // w.editMode ? 
                          // <TableCell><InputController onFieldChange={() => onValueChange(w.no)} error={errors['ExtraHours_'+w.no]} control={control} register={{ ...register('ExtraHours_'+w.no) }} /></TableCell>
                          // :
                          // <TableCell onClick={function () { onRowClick(w.no) }}>{w.ExtraHours}</TableCell>
                        }
                        {
                          w.editMode ?
                            <TableCell><InputController onFieldChange={() => onValueChange(w.no)} error={errors['HourSalary_' + w.no]} control={control} symbol="€" register={{ ...register('HourSalary_' + w.no) }} /></TableCell>
                            :
                            <TableCell onClick={function () { onRowClick(w.no) }}>
                              {new Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(w.HourSalary)}
                            </TableCell>
                        }
                        {
                          <TableCell onClick={function () { onRowClick(w.no) }}>
                            {new Intl.NumberFormat('en-GB', {
                              style: 'currency',
                              currency: 'EUR',
                            }).format(w?.contributions)}
                          </TableCell>
                        }
                        {
                          <TableCell onClick={function () { onRowClick(w.no) }}>
                            {new Intl.NumberFormat('en-GB', {
                              style: 'currency',
                              currency: 'EUR',
                            }).format(w?.taxes)}
                          </TableCell>
                        }
                        {
                          <TableCell onClick={function () { onRowClick(w.no) }}>
                            {new Intl.NumberFormat('en-GB', {
                              style: 'currency',
                              currency: 'EUR',
                            }).format(w?.neto)}
                          </TableCell>
                        }
                        {
                          w.editMode ?
                            <TableCell><InputController onFieldChange={() => onValueChange(w.no)} error={errors['Bonus_' + w.no]} control={control} symbol="€" register={{ ...register('Bonus_' + w.no) }} /></TableCell>
                            :
                            <TableCell onClick={function () { onRowClick(w.no) }}>
                              {new Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(w.Bonus)}
                            </TableCell>
                        }
                        {
                          w.editMode ?
                            <TableCell><InputController onFieldChange={() => onValueChange(w.no)} error={errors['Penalties_' + w.no]} control={control} symbol="€" register={{ ...register('Penalties_' + w.no) }} type="number" /></TableCell>
                            :
                            <TableCell onClick={function () { onRowClick(w.no) }}>
                              {new Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: 'EUR',
                              }).format(w.Penalties)}
                            </TableCell>
                        }
                        {/* <TableCell>{"€ " + total(w.no)}</TableCell> */}
                        <TableCell>{"€ " + w?.total}</TableCell>
                        <TableCell>
                          <ButtonGroup size="small">
                            <Button onClick={() => deleteRow(w.no)}>
                              <DeleteIcon />
                            </Button>
                            {salaries.length === index + 1 &&
                              <Button onClick={() => addRow()}>
                                <AddIcon />
                              </Button>
                            }
                          </ButtonGroup>
                        </TableCell>
                      </TableRow>
                    ))}
                  <TableRow className='d-none1' style={{ fontWeight: 'bold' }}>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>{calculateColumnTotal(salaries, 'Salary')}</TableCell>
                    <TableCell>{calculateColumnTotal(salaries, 'Advances')}</TableCell>
                    <TableCell>
                      {
                        parseFloat(parseFloat(calculateColumnTotal(salaries, 'ExtraHours')) +
                          parseFloat(calculateColumnTotal(salaries, 'ExtraHoursWeekend')) +
                          parseFloat(calculateColumnTotal(salaries, 'ExtraHoursHoliday'))).toFixed(2)
                      }
                    </TableCell>
                    <TableCell>{calculateColumnTotal(salaries, 'HourSalary')}</TableCell>
                    <TableCell>{calculateColumnTotal(salaries, 'contributions')}</TableCell>
                    <TableCell>{calculateColumnTotal(salaries, 'taxes')}</TableCell>
                    <TableCell>{calculateColumnTotal(salaries, 'neto')}</TableCell>
                    <TableCell>{calculateColumnTotal(salaries, 'Bonus')}</TableCell>
                    <TableCell>{calculateColumnTotal(salaries, 'Penalties')}</TableCell>
                    <TableCell>{calculateColumnTotal(salaries, 'total')}</TableCell>

                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            {/* </>} */}
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={salaries.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </CardContent>
        </Card>
      </Fragment>
    </div>
  );
}
